import template from './newUserForm.html';
import './newUserForm.scss';

export class NewUserFormController {
  constructor($scope) {
    'ngInject';

    this.$scope = $scope;
    this.nameError = '';
    this.emailError = '';
    this.userInfo = {
      name: '',
      email: '',
    };
  }
  $onInit() {
    if (this.initialEmail && this.initialEmail) {
      this.userInfo.name = this.initialName;
      this.userInfo.email = this.initialEmail;
    }
  }
  $onChanges({ error }) {
    if (error && error.currentValue) {
      this.emailError = error.currentValue;
    }
  }
  cancel() {
    this.onCancel();
  }
  save() {
    if (!this.loading) {
      const { form } = this;
      if (form.$valid) {
        this.nameError = '';
        this.emailError = '';
        this.onSave(this.userInfo);
      } else if (form.$error.email) {
        this.emailError = 'Please enter a valid e-mail address';
      } else {
        this.nameError = this.userInfo.name ? '' : 'Please complete this field';
        this.emailError = this.userInfo.email ? '' : 'Please complete this field';
      }
    }
  }
  selectScope(item) {
    this.selectedScope = item;
    this.onScopeChange({ scope: item });
  }
  get form() {
    return this.$scope.nzNewUserForm_form;
  }
}

export default {
  controller: NewUserFormController,
  template,
  bindings: {
    loading: '<',
    error: '<',
    initialName: '@',
    initialEmail: '@',
    selectedScope: '<',
    scopes: '<',
    showScopes: '<',
    onScopeChange: '&',
    onSave: '&',
    onCancel: '&',
  },
};
